// @ts-nocheck

import { action } from 'typesafe-actions'
import { LoadingActions } from './types'

export const setLoading = (blur?: boolean) =>
  action(LoadingActions.SET_LOADING, blur)

export const clearLoading = () => action(LoadingActions.CLEAR_LOADING)
